import { render, staticRenderFns } from "./TranslationJobDetail.vue?vue&type=template&id=461ec0fc"
import script from "./TranslationJobDetail.vue?vue&type=script&lang=ts"
export * from "./TranslationJobDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports